import { createSlice } from '@reduxjs/toolkit';

export type WebSliceState = {
  audioIsPlaying: boolean;
};

const initialState: WebSliceState = {
  audioIsPlaying: false,
};

const webSlice = createSlice({
  name: 'web',
  initialState,
  reducers: {
    updateAudioIsPlaying(state, action) {
      state.audioIsPlaying = action.payload;
    },
  },
});
export const { updateAudioIsPlaying } = webSlice.actions;

export const webReducer = webSlice.reducer;
